export default function WtdEndDate(sdate, time) {
  var StartDate = new Date(sdate); // create a date object directly from `dob1` argument

  const enddate = StartDate.setFullYear(StartDate.getFullYear() + time);

  return enddate;
}
